import { render } from "./resultats.vue?vue&type=template&id=537c2fa3"
import script from "./resultats.vue?vue&type=script&lang=js"
export * from "./resultats.vue?vue&type=script&lang=js"

import "./resultats.vue?vue&type=style&index=0&id=537c2fa3&lang=scss"
script.render = render

export default script